const project = {
  slug: "email-outreach-campaign-builder",
  title: "Email Outreach Campaign Builder",
  oneLiner: "Uploads contact sheets, dedupes, enriches, and generates human-like outreach emails.",
  role: ["Automation Engineer", "AI Workflow Designer"],
  category: "AI/ML",
  clientOrOrg: "Automation Engineering (n8n + OpenAI Workflows)",
  timeframe: { start: "2025-02", status: "Shipped" },
  domain: ["Automation", "SalesOps", "AI"],
  tech: ["n8n", "OpenAI", "Google Sheets", "APIs"],
  links: { demo: "https://example.com" },
  impact: [
    "Automated B2B outreach prep with normalization, dedupe, enrichment, and AI-crafted emails.",
    "Improved deliverability with cleaner lists and contextual copy."
  ],
  responsibilities: [
    "Built file ingest + schema normalization",
    "Implemented dedupe and enrichment steps",
    "Created GPT prompts for human-like email bodies",
    "Synced campaign results back to Sheets"
  ],
  features: [
    "Contact sheet ingestion",
    "Lead normalization & dedupe",
    "Dataset enrichment",
    "AI email generation",
    "Google Sheets export"
  ],
  architecture: [
    "n8n pipelines for ingest, clean, enrich",
    "OpenAI for persona-aware copy",
    "Sheets integration for reporting"
  ],
  seo: {
    title: "Email Outreach Campaign Builder - n8n + OpenAI",
    description: "Automated B2B outreach builder that cleans lists, enriches leads, and writes AI emails with reporting to Sheets."
  },
  cover: "/assets/email-outreach/email-outreach.png"
};

export default project;
